import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Critical resource hints
const setupCriticalResources = () => {
  // DNS prefetch for CDN
  const dnsPrefetch = document.createElement('link');
  dnsPrefetch.rel = 'dns-prefetch';
  dnsPrefetch.href = 'https://cdn.magicpatterns.com';
  document.head.appendChild(dnsPrefetch);
  // Preload hero image (LCP optimization)
  const heroPreload = document.createElement('link');
  heroPreload.rel = 'preload';
  heroPreload.as = 'image';
  heroPreload.href = 'https://cdn.magicpatterns.com/uploads/kpqeeJXPW4oe2uvVr6ePv9/LIBRO_EL_REINICIO_BIOLOGICO_2B_BONOS_(1)_(1).png';
  heroPreload.fetchPriority = 'high';
  document.head.appendChild(heroPreload);
};
setupCriticalResources();
render(<App data-id="element-152" />, document.getElementById('root'));